import { ErrorLogsState } from './interface';

export const initialState: ErrorLogsState = {
  list: {
    data: [],
    status: null,
    deleteStatus: null,
  },
  detail: {
    data: null,
    status: null,
  },
  settings: {
    data: null,
    status: null,
    saveStatus: null,
  },
  filters: {
    from: '',
    to: '',
    status: '',
    path: '',
    userId: '',
  },
};
